import React from 'react';

import Item from './Item';

const List = ({ animate }) => (
  <ul className="absolute top-0" style={{ right: '24px' }}>
    {itemsList.map((item, i) => (
      <Item item={item} animate={animate} delay={i} />
    ))}
  </ul>
);

export default List;

const itemsList = [
  {
    title: 'Date',
    value: 'May 22, 2019',
    color: '#ED72E2'
  },
  {
    title: 'Item_1',
    value: 'Granola Bowl',
    color: '#FFCA28'
  },
  {
    title: 'Item_2',
    value: 'Vanilla Latte',
    color: '#FFCA28'
  },
  {
    title: 'Price_1',
    value: '$9.00',
    color: '#943CFF'
  },
  {
    title: 'Price_2',
    value: '$5.00',
    color: '#943CFF'
  },
  {
    title: 'Total',
    value: '$15.15',
    color: '#72CE7B'
  }
];
